import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = toCamelCase(obj?.[key]);
    return acc;
  }, {});
};

const toSnakeCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toSnakeCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const snakeKey = key?.replace(/[A-Z]/g, (letter) => `_${letter?.toLowerCase()}`);
    acc[snakeKey] = toSnakeCase(obj?.[key]);
    return acc;
  }, {});
};

export const experienceService = {
  async getAllExperience() {
    const { data, error } = await supabase?.from('experience')?.select('*')?.order('display_order', { ascending: true });

    if (error) throw error;
    return toCamelCase(data);
  },

  async getExperienceById(id) {
    const { data, error } = await supabase?.from('experience')?.select('*')?.eq('id', id)?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async createExperience(experienceData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const snakeData = toSnakeCase({
      ...experienceData,
      createdBy: user?.id
    });

    const { data, error } = await supabase?.from('experience')?.insert(snakeData)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async updateExperience(id, experienceData) {
    const snakeData = toSnakeCase(experienceData);

    const { data, error } = await supabase?.from('experience')?.update(snakeData)?.eq('id', id)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async deleteExperience(id) {
    const { error} = await supabase?.from('experience')?.delete()?.eq('id', id);

    if (error) throw error;
  }
};
